import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeLandingRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-landing',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
	exact: true,
};
